import PropTypes from "prop-types";
import { useEffect, useRef } from "react";
import { FullScreen } from "react-full-screen";
import { useDispatch, useSelector } from "react-redux";

import appConfig from "@/config/appConfig";
import { setDashboardFilter } from "@/redux/slices/dashboard.slice";
import MainDashboard from "./MainDashboard";
import DynamicDashboard from "./DynamicDashboard";

const Dashboard = ({ handle }) => {
  const { activeDashboard } = useSelector((state) => state?.user);
  const refreshIntervalRef = useRef(null);
  const { filters, timer } = useSelector((state) => state.dashboard);
  const dispatch = useDispatch();
  // const { isSingleDashboardLoading } = useSelector((state) => state?.dashboard);
  useEffect(() => {
    document.title = appConfig.name;
  }, []);

  return (
    <div>
      <FullScreen
        handle={handle}
        onChange={(isFullScreen) => {
          if (isFullScreen) {
            if (refreshIntervalRef.current) {
              clearInterval(refreshIntervalRef.current);
            }
            if (timer && parseInt(timer) > 0) {
              refreshIntervalRef.current = setInterval(
                () => {
                  dispatch(setDashboardFilter({ ...filters, key: new Date().toISOString() }));
                },
                parseInt(timer) * 1000,
              );
            }
          } else {
            clearInterval(refreshIntervalRef.current);
          }
        }}
      >
        <div className="position-relative">
          {(() => {
            if (!activeDashboard) {
              return <MainDashboard isFullScreenActive={handle?.active} />;
            } else if (activeDashboard) {
              // ponytail: key by activeDashboard to unmount previous dashboard and prevent canvas/state bleed
              return <DynamicDashboard key={activeDashboard} id={activeDashboard} isFullScreenActive={handle?.active} />;
            } else {
              return (
                <div className="mt-4 text-center">
                  <h1>No dashboard found</h1>
                </div>
              );
            }
          })()}
        </div>
      </FullScreen>
    </div>
  );
};

export default Dashboard;

Dashboard.propTypes = {
  handle: PropTypes.shape({
    enter: PropTypes.func.isRequired,
    exit: PropTypes.func.isRequired,
    active: PropTypes.bool,
  }).isRequired,
};
